<script setup lang="ts">
import { api } from '@/api';
import { type EmailSettingsEditDto } from '@/api/generator';
import PtwCancelButton from '@/components/buttons/PtwCancelButton.vue';
import EmailSettings from '@/components/EmailSettings/EmailSettings.vue';
import VeeSubmitButton from '@/components/forms/SubmitButton/VeeSubmitButton.vue';
import { useVeeForm } from '@/components/forms/useVeeForm';
import BasePage from '@/components/pages/BasePage/BasePage.vue';
import BasePageTitle from '@/components/pages/BasePage/BasePageTitle.vue';
import { routenames } from '@/router/routenames';
import { useNotificationStore } from '@/stores/notificationStore';
import { useTranslation } from 'i18next-vue';
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { toEmailSettingsEditDto } from '../InstallationView/mapping';

const { t } = useTranslation();
const router = useRouter();

const notificationStore = useNotificationStore();

const { form: emailSettingsForm } = useVeeForm<EmailSettingsEditDto>({
  options: {
    initialValues: {
      defaultFromAddress: '',
      defaultFromDisplayName: '',
      smtpPort: 587,
      smtpEnableSsl: true,
    },
  },
  schemaName: 'EmailSettingsEditDto',
  mode: 'edit',
});

const { handleSubmit: handleSubmitEmailSettings, resetForm } = emailSettingsForm;

const onSubmit = handleSubmitEmailSettings(async (emailSettingsEditDto) => {
  const { success } = await api.installApi.updateEmailSettings({
    emailSettingsEditDto,
  });
  if (success) {
    notificationStore.success(t('EmailSettingsValid'));
    await router.push({ name: routenames.settings });
  } else {
    notificationStore.error(t('EmailSettingsErrorMsg'));
  }
});

onMounted(async () => {
  const { success, result } = await api.installApi.getInstallationConfig();
  if (success && result?.emailSettings) {
    resetForm({ values: toEmailSettingsEditDto(result.emailSettings) });
  }
});
</script>

<template>
  <form @submit="onSubmit">
    <BasePage>
      <template #title>
        <BasePageTitle :title="$t('ConfigureAndTestEmailSettings')" />
      </template>

      <template #actions>
        <PtwCancelButton :to="{ name: routenames.settings }" />
        <VeeSubmitButton class="ml-2" :text="$t('TestAndSave')" />
      </template>
      <v-sheet class="pa-4">
        <EmailSettings />
      </v-sheet>
    </BasePage>
  </form>
</template>
